import Big from 'big.js';
import { ChangeEvent, useCallback } from 'react';
import { BigRoundMode } from '@/modules/common/constants/big-round-mode.ts';
import { TextInput } from 'ui';
import { RoundingType } from 'api';

interface SharesInputProps {
  name?: string;
  error?: string;
  label?: string;
  disabled?: boolean;
  placeholder?: string;
  value?: string | number;
  allowFractional?: boolean;
  roundingType?: RoundingType;
  onChange: (value: number | string) => void;
}

const SharesInput = ({
  name,
  label,
  error,
  disabled,
  value,
  placeholder,
  allowFractional = true,
  roundingType = RoundingType.Up,
  onChange,
}: SharesInputProps) => {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value || '';
      if (!value || isNaN(+value)) {
        onChange(value);
        return;
      }
      let quantity = new Big(value);
      if (allowFractional) {
        if (roundingType === RoundingType.Up) {
          quantity = quantity.round(2, BigRoundMode.roundHalfUp);
        } else {
          quantity = quantity.round(2, BigRoundMode.roundDown);
        }
      } else {
        quantity = quantity.round(0);
      }
      onChange(Number(quantity.valueOf()));
    },
    [allowFractional, onChange, roundingType],
  );

  return (
    <TextInput
      error={error}
      label={label}
      name={name ?? 'shares'}
      type="number"
      disabled={disabled}
      min={allowFractional ? 0.0001 : 1}
      step={allowFractional ? 0.0001 : 1}
      value={value ?? ''}
      placeholder={placeholder}
      onChange={handleChange}
    />
  );
};

export default SharesInput;
